export const environment = {
  GAME_RENDERING_IFRAME:
    "https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-iframe/iframe-rendering-grm.html",
  // Services
  USER_API: "https://aarpcloud.cdn.arkadiumhosted.com/arenax-api-user/api/v1",
  SCORE_API: "https://aarpcloud.cdn.arkadiumhosted.com/arenax-api-score/api/v1",
  FRIEND_API:
    "https://aarpcloud.cdn.arkadiumhosted.com/arenax-api-friend/api/v1",
  GAME_API_URL:
    "https://arenacloud.cdn.arkadiumhosted.com/game-api-fd-live",

  // Blobs
  FEED_API:
    "https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-game-feeds-content",

  AARP_GAMES_BLOB:
    "https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-games",
  AARP_CONST_BLOB:
    "https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-aarp",

  // Score filter Blobs
  SCORE_FLITER_BLOB:
    "https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-score-filter",
  //
  AARP_ENV: "production",
  FEED_NAME: "AARP",
  FEED_ID: "45",
  FAKE_GAME_NAME: "Fake_game",

  ARENA_DOMAIN: "games.aarp.org",
  PROD_HOST: "https://games.aarp.org",
  AARP_PROD_HOST: "https://www.aarp.org/games",

  // AUTH
  AARP_AUTH_BASE: "https://secure.aarp.org/applications/user/auth",
  AARP_LOGIN_BASE: "https://secure.aarp.org/applications/user/login",
  AARP_MEMBER_JOIN: "https://appsec.aarp.org/mem/join",
  AARP_REGISTER_BASE: "https://secure.aarp.org/applications/user/register",
  AARP_LOGOUT_BASE: "https://secure.aarp.org/applications/user/logout",

  AARP_AUTH_CLIENT_ID: "0oa355eqko19gwV4u2p7",
  ARENA_TOKEN_EXPIRATION: 864000,
  // temporary
  REWARD_TOKEN_EXPIRATION: 39600, // 11 hours

  // PUZZLE
  PUZZLE_API:
    "https://aarpcloud.cdn.arkadiumhosted.com/aarp-trivia-public-prod/api",

  AARP_OPTIN_BASE:
    "https://services.share.aarp.org/applications/user/programOptIn",
};
